import gCard from "@/components/g-card/g-card.vue";
import gForm from "@/components/g-form/g-form.vue";
import gDateInput from "@/components/g-date-input/g-date-input.vue";
import gButton from "@/components/g-button/g-button.vue";
import gDataTable from "@/components/g-data-table/g-data-table.vue";
import ProdutoController from "@/shared/controllers/produto/produtoController";
import {mask} from 'vue-the-mask'


const name = 'ReclamacaoTecnicaComercialFormulario'
export default {
  name,
  directives: {mask},
  components: {
    'g-card': gCard,
    'g-form': gForm,
    'g-date-input':gDateInput,
    'g-button': gButton,
    'g-data-table': gDataTable
  },

  props: { },

  mounted () {
    // this.getPedidos()
    this.iniciaFormulario()
    this.getProduto()
  },

  updated () { },

  data () {
    return {
      bloqueiabotoes: false,
      PedidoArray: [],
      info: '',
      pedido: 0,
      parcela:'',
      ordemservico:'',
      notafiscal:'',
      quantidade: 0,
      descricao: '',
      cnpj: '',
      razaoSocial: '',
      codigo: '',
      unidade: '',
      acompanhaamostra: false,
      ClienteSelecionado: '',
      EmpresaSelecionada: '',
      RepresentanteSelecionado: '',
      ProdutoArray: [],
      produto: null,
      NumeroFormulario: '',
      popup: false
    }
  },

  methods: {

    PesquisaPedidoByProduto(){
      if (this.produto != null )
      {
        this.axios({
          method: 'get',
          url: process.env.VUE_APP_WEB_API +  `Pedido/GetPedidosUltimosDoisAnosByProdutoId/${this.produto}`,
        })
        .then((response) => {
          this.PedidoArray = response.data.data
        })
        .catch(() => {
        })

      }
      else{
        return
      }
    },

    getProduto() {
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        ProdutoController.GetProdutoByClienteEmpresaRepresentante(this.ClienteSelecionado, this.EmpresaSelecionada, this.RepresentanteSelecionado).requisicao
        .then((res) => {
          this.ProdutoArray = res.data.data
        })
        .catch(() => {
        })
      }, 1000);
    },

    voltar() {
      this.$router.push(`/reclamacao-tecnica-comercial/`)
    },
    iniciaFormulario(){
      this.ClienteSelecionado = this.$route.params.idcliente
      this.EmpresaSelecionada = this.$route.params.idempresa
      this.RepresentanteSelecionado = this.$route.params.idrepresentante
      this.axios({
         method: 'Post',
         url: process.env.VUE_APP_WEB_API +  `reclamacao/GetInfoFormulario`,
         data: {
           Id: this.ClienteSelecionado,
           EmpresaId: this.EmpresaSelecionada
         }
       })
       .then((response) => {
         this.infoFormulario = response.data.data,
         this.cnpj = response.data.data.cnpj,
         this.unidade = response.data.data.nomeEmpresa,
         this.codigo = response.data.data.codigoExterno,
         this.razaoSocial = response.data.data.razaoSocial
       })
       .catch(() => {
       })
     },
     valida(){
        if(this.descricao == "") {
          this.$toast.add({ severity: 'error', summary: 'Erro ao preencher dados', detail: 'É necessário informar a Descrição!', life: 5000 })
          }
        if(this.pedido == "") {
          this.$toast.add({ severity: 'error', summary: 'Erro ao preencher dados', detail: 'É necessário informar o Pedido!', life: 5000 })
          }
        if(this.parcela == "") {
          this.$toast.add({ severity: 'error', summary: 'Erro ao preencher dados', detail: 'É necessário informar a Parcela!', life: 5000 })
        }
        if(this.quantidade == "") {
          this.$toast.add({ severity: 'error', summary: 'Erro ao preencher dados', detail: 'É necessário informar a Quantidade com Problema!', life: 5000 })
          }

        if(this.notafiscal == "") {
          this.$toast.add({ severity: 'error', summary: 'Erro ao preencher dados', detail: 'É necessário informar a Nota Fiscal!', life: 5000 })
          }

      if (this.descricao.length < 10 ) {
        this.$toast.add({ severity: 'error', summary: 'Erro ao preencher dados', detail: 'Descrição mínima de 10 caracteres', life: 5000 })
        }
      else {
        this.gerarFormulario()  
        }
     },
     gerarFormulario(){
      this.bloqueiabotoes=true
      this.$isLoading(true)
      this.axios({
        method: 'Post',
        url: process.env.VUE_APP_WEB_API +  `reclamacao/PostInfoFormulario`,
        data: {
          EmpresaId: this.EmpresaSelecionada,
          RepresentanteId: this.RepresentanteSelecionado,
          ClienteId: this.ClienteSelecionado,
          NumeroParcela: this.parcela,
          PedidoId: this.pedido,
          NotaFiscal : this.notafiscal,
          AcompanhaAmostra: this.acompanhaamostra,
          NumeroOrdemServico: this.ordemservico,
          QuantidadeComProblema: this.quantidade,
          DescricaoProblema: this.descricao
        }
      })
      .then((response) => {
        this.ReclamacaoId = response.data.data
      
        this.bloqueiabotoes=false;

        this.getNumeroFormulario()
      })
      .catch(() => {
        this.bloqueiabotoes=false;
      })
      .finally(
        this.$isLoading(false))
    },

    getNumeroFormulario(){

      this.axios({
        method: 'Get',
        url: process.env.VUE_APP_WEB_API +  `reclamacao/GetNumeroFormulario/${this.ReclamacaoId}`,
      })
      .then((response) => {
        this.NumeroFormulario = response.data.message
        this.popup = true

      })
      .catch(() => {
      })
    },

    consultarFormulario (){
      this.$router.push(`/reclamacao-tecnica-comercial/`)
    },

  }
}